import React from 'react';

/**
 * Sticky-ish header shown above each month bucket in MediaGrid.
 * Shows "April 2026 · 12 items" + a "select all in month" checkbox.
 */
const MonthGroupHeader = ({ label, count, allSelected, someSelected, onToggle }) => {
  return (
    <div className="mv2-month-header">
      <label className="mv2-month-header__label">
        <input
          type="checkbox"
          checked={!!allSelected}
          ref={(el) => {
            if (el) el.indeterminate = !allSelected && !!someSelected;
          }}
          onChange={onToggle}
          aria-label={`Select all in ${label}`}
        />
        <span className="mv2-month-header__title">{label}</span>
        <span className="mv2-month-header__count">{count} item{count === 1 ? '' : 's'}</span>
      </label>
    </div>
  );
};

export default MonthGroupHeader;
